// import { useEffect } from 'react';

// const FixedFooter = () => {
//   useEffect(() => {
//     const existing = document.getElementById('absolin-fixed-footer');
//     if (existing) existing.remove();

//     const footerContainer = document.createElement('div');
//     footerContainer.id = 'absolin-fixed-footer';
//     footerContainer.style.cssText = `
//       position: fixed !important;
//       bottom: 15px !important;
//       left: 0 !important;
//       right: 0 !important;
//       width: 100% !important;
//       text-align: center !important;
//       z-index: 999999 !important;
//       pointer-events: none !important;
//     `;

//     const link = document.createElement('a');
//     link.href = 'https://www.absolinsoft.com';
//     link.target = '_blank';
//     link.rel = 'noopener noreferrer';
//     link.innerHTML = 'Powered by <span style="font-weight: 600;">Absolin</span>';
//     link.style.cssText = `
//       color: #2C2B2B !important;
//       opacity: 0.6 !important;
//       pointer-events: auto !important;
//       font-size: 0.75rem !important;
//       text-decoration: none !important;
//       transition: opacity 0.3s ease !important;
//     `;

//     link.onmouseenter = () => link.style.opacity = '0.8';
//     link.onmouseleave = () => link.style.opacity = '0.6';

//     footerContainer.appendChild(link);
//     (document.scrollingElement || document.documentElement).appendChild(footerContainer);

//     return () => {
//       const footer = document.getElementById('absolin-fixed-footer');
//       if (footer) footer.remove();
//     };
//   }, []);

//   return null;
// };

// export default FixedFooter;


import React from 'react'
import { useNavigate } from 'react-router-dom'

const FixedFooter = () => {
  const navigate = useNavigate();

  return (
    <div className='pt-7 mt-5' style={{ textAlign: "center" }}>
      <div 
        onClick={() => window.open('https://www.absolinsoft.com', '_blank')}
        style={{ cursor: "pointer" }}
      >
        Powered by <span style={{ fontWeight: "600" }}>Absolin</span>
      </div>
    </div>
  )
}

export default FixedFooter


